  renderChrome();
  wireMenu();
  if (typeof wireMenuSeq === 'function') wireMenuSeq();
  if (typeof wirePlatePour === 'function') wirePlatePour();
  if (param('menuopen')) {
    /* an auto-open that outruns the seq frames would play the still wash instead;
       the door waits until the frames are in, or gives up waiting */
    (function () {
      const kick = function () { document.getElementById('menu-btn').click(); };
      const t0 = Date.now();
      (function wait() {
        if (document.body.dataset.seq || Date.now() - t0 > 2000) { kick(); return; }
        setTimeout(wait, 40);
      })();
    })();
  }

  const RENDER = {
    'landing': renderLanding,
    'list': renderList,
    'posts': renderPosts,
    'post-event': renderPostEvent,
    'item': renderItem,
    /* assets/legal.js rides only legal.html, so the reference must survive its absence */
    'legal': typeof renderLegal === 'function' ? renderLegal : null,
    'cart': typeof renderCart === 'function' ? renderCart : null
  };
  if (RENDER[page]) RENDER[page]();
  /* the template renders the cart word on load, so its measure is taken here as
     well as on add, and again once the head's type settles */
  if (typeof seatCartCorner === 'function') {
    seatCartCorner();
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(seatCartCorner);
    window.addEventListener('resize', seatCartCorner);
  }
  /* after the page renderer: the landing's plate and register exist only now */
  wirePlateExit();

  /* ---------- the header withdraws while the page is being read ----------
     a trackpad reverses by a pixel constantly, so nothing flips until the page
     has gone eight pixels the other way */
  function wireHeader() {
    const marks = Array.prototype.slice.call(document.querySelectorAll('.corner'));
    if (!marks.length || param('shot')) return;
    const TURN = 8, TOP = 90;
    let last = window.scrollY, anchor = last, away = false;

    (function frame() {
      requestAnimationFrame(frame);
      const y = window.scrollY;
      if (y === last) return;
      const down = y > last;
      /* the anchor is where the page last changed its mind */
      if (down !== (y > anchor)) anchor = last;
      const moved = Math.abs(y - anchor);
      last = y;
      let want = y > TOP && down && moved > TURN;
      if (!down && moved > TURN) want = false;
      if (y <= TOP) want = false;
      if (want === away) return;
      away = want;
      marks.forEach(function (el) { el.classList.toggle('away', away); });
    })();
  }
  wireHeader();

  /* ---------- the scroll's own mark ----------
     drawn over the page because a native styled bar takes a gutter that shows
     paper down the dark hero's side; the grab area is the rail's full 24px */
  function wireScrollMark() {
    if (param('shot')) return;

    const rail = document.createElement('div');
    rail.className = 'scroll-rail';
    rail.setAttribute('aria-hidden', 'true');
    const mark = document.createElement('div');
    mark.className = 'scroll-mark';
    rail.appendChild(mark);
    document.body.appendChild(rail);

    const doc = document.documentElement;
    let span = 0, travel = 0, idle = null, grabbed = null;

    /* not per scroll event: reading scrollHeight forces layout under a page
       driven at 60fps */
    function measure() {
      travel = doc.scrollHeight - window.innerHeight;
      if (travel <= 0) { mark.style.height = '0'; return; }
      span = Math.max(48, window.innerHeight * window.innerHeight / doc.scrollHeight);
      mark.style.height = Math.round(span) + 'px';
      place();
    }

    /* rounded so the bar's ends land on whole pixels */
    function place() {
      if (travel <= 0) return;
      const at = Math.min(1, Math.max(0, window.scrollY / travel));
      mark.style.transform = 'translateY(' + Math.round(at * (window.innerHeight - span)) + 'px)';
    }

    function show() {
      place();
      mark.classList.add('live');
      clearTimeout(idle);
      idle = setTimeout(function () { mark.classList.remove('live'); }, 800);
    }

    /* Lenis owns the scroll position while it runs; going around it leaves the
       two disagreeing about where the page is */
    function goTo(y, carried) {
      y = Math.max(0, Math.min(travel, y));
      if (lenis) lenis.scrollTo(y, carried ? {} : { immediate: true });
      else window.scrollTo({ top: y, behavior: carried ? 'smooth' : 'auto' });
    }

    /* the drag holds the grabbed point, so the bar stays under the pointer */
    mark.addEventListener('pointerdown', function (e) {
      grabbed = e.clientY - mark.getBoundingClientRect().top;
      mark.setPointerCapture(e.pointerId);
      rail.classList.add('held');
      show();
      e.preventDefault();
    });

    mark.addEventListener('pointermove', function (e) {
      if (grabbed === null) return;
      const free = window.innerHeight - span;
      if (free <= 0) return;
      goTo(((e.clientY - grabbed) / free) * travel, false);
      show();
    });

    function release(e) {
      if (grabbed === null) return;
      grabbed = null;
      if (mark.hasPointerCapture(e.pointerId)) mark.releasePointerCapture(e.pointerId);
      rail.classList.remove('held');
    }
    mark.addEventListener('pointerup', release);
    mark.addEventListener('pointercancel', release);

    /* the rail pages one screen toward the click, less a keeping-place overlap */
    rail.addEventListener('pointerdown', function (e) {
      if (e.target === mark || grabbed !== null || travel <= 0) return;
      const box = mark.getBoundingClientRect();
      const away = e.clientY < box.top ? -1 : 1;
      const carried = !window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      goTo(window.scrollY + away * window.innerHeight * 0.9, carried);
      show();
    });

    measure();
    window.addEventListener('scroll', show, { passive: true });
    window.addEventListener('resize', measure);
    /* the lists and the lightbox change the document's height after it is first measured */
    if (window.ResizeObserver) new ResizeObserver(measure).observe(document.body);
  }
  wireScrollMark();

  wireSmoothScroll();

  /* clock, shared by all pages */
  const clock = document.getElementById('clock');
  if (clock) {
    const tick = function () {
      clock.textContent = new Date().toLocaleTimeString('en-GB', { timeZone: 'Asia/Seoul', hour12: false });
    };
    tick(); setInterval(tick, 1000);
  }
